// extracted by mini-css-extract-plugin
module.exports = {"articleMain":"SectionArticle_articleMain__12y3M","noSidePaddings":"SectionArticle_noSidePaddings__RUBKd"};